/**
 * 配置开发路径
 * test */
/*export const HOST = 'http://test.52shuxue.com';
export const sijiWxUrl = 'http://api.52shuxue.com';
export const wxAppid ='wx5fce4291ad949abf';
export const eId = 69;
export const qId= 11;*/


/*test*/
// export const HOST = 'https://test.52shuxue.com';
// export const sijiWxUrl = 'https://tapi.52shuxue.com';
// export const wxAppid = 'wx5fce4291ad949abf';
// export const rangeTimmers = "3月14日 13:59-3月21日 13:59";
// export const startTimmers = "2020-03-14 13:59:00";
// export const endTimmers = "2020-03-21 13:59:59";
// export const reportTimmers = "2020/03/11 13:59";
// export const reportText = "03月14日14时";
// export const startTexts = "03月14日14时00分";
// export const elId = 799;
/*uat*/

/*export const HOST = 'http://uat.52shuxue.com';
export const sijiWxUrl = 'http://api.52shuxue.com';
export const wxAppid ='wx5fce4291ad949abf';
export const eId = 90;
export const qId = 13;
export const rangeTimmers =  "10月11日 16:00-10月20日 23:59";
export const startTimmers = "2019-10-11 16:00:00";
export const endTimmers = "2019-10-20 23:59:59";
export const reportTimmers = "2019/10/21 16:00";
export const reportText =  "10月21日16时";
export const startTexts = "10月11日16时00分";*/

/*tars*/
export const HOST = 'https://tars.52shuxue.com';
export const sijiWxUrl = 'https://api.52shuxue.com';
export const wxAppid = 'wx5fce4291ad949abf';
export const rangeTimmers = "3月14日 13:59-3月21日 13:59";
export const startTimmers = "2020-03-14 13:59:00";
export const endTimmers = "2020-03-21 13:59:59";
export const reportTimmers = "2020/03/11 13:59";
export const reportText = "03月14日14时";
export const startTexts = "03月14日14时00分";
export const elId = 868;
const pageTitles = "2020年3.14数学文化节";
document.title = pageTitles;
/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

var qs = require('querystring');
export const parseUrl = (queryObj) => {
  queryObj = queryObj || {};
  let queryParams = null;
  const search = window.location.href;
  if (search.indexOf('?') != -1) {
    queryParams = search.substr(search.indexOf('?') + 1);
  }
  if (!queryParams) return;
  queryObj = Object.assign(queryObj, qs.parse(queryParams));
  return queryObj;
};


/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
}
export const unique = (arr) => {
  var hash = {};

  return arr.filter(function (element) {
    if (hash.hasOwnProperty(element)) {
      return false;
    }
    hash[element] = true;

    return true;
  });
}


/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}

/**
 * 存储cookies
 * */
export const setCookie = (name, value) => {
  // 默认过时时间为1天
  let Days = 1;
  let exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}

/**
 *读取cookies
 * */
export const getCookie = (name) => {
  let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
};

/**
 *删除cookies
 * */
export const removeCookie = (name) => {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) {
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  }
}

/***
 * 格式化时间
 * */
export const format = () => {
  var date = new Date();
  var seperator1 = "-";
  var seperator2 = ":";
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
    " " + date.getHours() + seperator2 + date.getMinutes() +
    seperator2 + date.getSeconds();
  return currentdate;
}


export const getCaption = (obj) => {
  var index = obj.lastIndexOf("/");
  obj = obj.substring(index + 1, obj.length);
  return obj;
}

// 手机号码校验
export const checkPhone = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入手机号码"));
  } else {
    let myreg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
    if (!myreg.test(value)) {
      callback(new Error("请输入正确格式的手机号码"));
    } else {
      callback();
    }
  }
};




// 手机号码格式验证
export const isPoneAvailable = (str) => {
  let myreg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
  if (!myreg.test(str)) {
    return false;
  } else {
    return true;
  }
}

// 去除空格
export const Trim = (str) => {
  return str.replace(/(^\s*)|(\s*$)/g, "");
}
// 删除数组中的空元素
export const removeNull = (array) => {
  for (var i = 0; i < array.length; i++) {
    if (array[i] == "" || typeof (array[i]) == "undefined") {
      array.splice(i, 1);
      i = i - 1;
    }
  }
  return array;
}
// 删除数组中重复的对象
export function deteleObject(obj) {
  var uniques = [];
  var stringify = {};
  for (var i = 0; i < obj.length; i++) {
    var keys = Object.keys(obj[i]);
    keys.sort(function (a, b) {
      return (Number(a) - Number(b));
    });
    var str = '';
    for (var j = 0; j < keys.length; j++) {
      str += JSON.stringify(keys[j]);
      str += JSON.stringify(obj[i][keys[j]]);
    }
    if (!stringify.hasOwnProperty(str)) {
      uniques.push(obj[i]);
      stringify[str] = true;
    }
  }
  uniques = uniques;
  return uniques;
}
// json数组去重
export const uniqueArray = (array, key) => {
  var result = [array[0]];
  for (var i = 1; i < array.length; i++) {
    var item = array[i];
    var repeat = false;
    for (var j = 0; j < result.length; j++) {
      if (item[key] == result[j][key]) {
        repeat = true;
        break;
      }
    }
    if (!repeat) {
      result.push(item);
    }
  }
  return result;
};
export const is_WeiXin = () => {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}
/*test*/

export const locationFunc = (locationUrl) => {
  pushHistory();
  let bool = false;
  setTimeout(function () {
    bool = true;
  }, 1500);
  window.addEventListener("popstate", function (e) {
    if (bool) {
      this.$router.push(locationUrl);
    }
    pushHistory();
  }, false);

  function pushHistory() {
    var state = {
      title: "title",
      url: ""
    };
    window.history.pushState(state, "title", "");
  }
}



// WEBPACK FOOTER //
// ./src/config/mUtils.js